import { useContext } from 'react';
import { MenuCloseContext } from '../contexts/menu';

const useMenu = () => useContext(MenuCloseContext);

export default useMenu;
